import React from 'react';
import {Flex, Card, Slider, Form, Formatted, List} from 'components';
import {map, useNamedSelector} from 'helpers';
import {store} from 'store';

export function RealityCheck() {
  const values = useNamedSelector('clarity.realityCheck');
  return (
    <Form initialValues={values} onChange={RealityCheck.save}>
      <List medium-gutter>
        <Formatted>
          <p>The first step in the process of creating your future life is to review and evaluate your present situation. This gives you a snapshot of where you are now, and also helps you figure out where you'd like things to change and what those changes might be.</p>
          <p>In order to do this, you will create your own Life Chart. Once completed, your Life Chart will give you a quick visual snapshot of where you stand in the different parts of your life today.</p>
          <p>Below, you see a bar chart divided into eight sections, each relates to a specific aspect of your life. Go from section to section and think about how satisfied you are with that part of your life. Set the level of the bar and your Life Chart will be created accordingly.</p>
        </Formatted>
        <Card medium>
          <List>
            { map(RealityCheck.fields, ( label, name ) =>
              <div key={name}>
                <Flex justified>
                  <b>{ label }</b>
                  <RealityCheck.Label name={name} />
                </Flex>
                <Slider min={1} max={10} filled="colored" name={name} />
              </div>
            ) }
          </List>
        </Card>
      </List>
    </Form>
  );
}

RealityCheck.fields = {
  'work-&-career': 'Work & Career',
  'health-&-fitness': 'Health & Fitness',
  'love-&-romance': 'Love & Romance',
  'wealth-&-finances': 'Wealth & Finances',
  'family-&-friends': 'Family & Friends',
  'spirituality-&-faith': 'Spirituality & Faith',
  'recreation-&-lifestyle': 'Recreation & Lifestyle',
  'personal-growth': 'Personal Growth',
}

RealityCheck.Label = function Label({ name }) {
  const labels = ['Very Unsatisfied', 'Unhappy', 'So-so', 'Pleased', 'Very Satisfied'];
  const value = useNamedSelector('clarity.realityCheck')[name];
  const ratio = (value-1)/10;
  const index = Math.floor(labels.length*ratio);
  return (
    <span>{ labels[index] }</span>
  );
}

RealityCheck.save = function save(data) {
  store.dispatch({
    type: 'CLARITY_UPDATE',
    name: 'reality-check',
    data,
  });
}
